<template>
  <div id="page-sources-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="6">
        <h2 class="breadcrumb">Πηγές</h2>
      </vs-col>
      <vs-col vs-align="right" vs-w="6">
        <vs-button @click="addOrEditShop" color="primary" type="filled" icon="add" class="ml-auto mb-2">
          Προσθήκη
        </vs-button>
      </vs-col>
    </vs-row>

    <!-- START: ADD NEW POPUP -->
    <div>
      <!-- start::validation observer -->
      <validation-observer v-slot="{invalid}">
        <!-- start::form -->
        <form>
          <vs-popup class="holamundo" :title="popUpTitle" :active="displayPopUp" @close="closePopUp">

            <!-- start::source -->
            <validation-provider rules="required" v-slot="{errors}">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Πηγή</span><span>*</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="name" />
                </div>
              </div>
              <div class="text-right text-danger">{{ errors[0] }}</div>
            </validation-provider>
            <!-- end::source -->

            <!-- start::url -->
            <validation-provider rules="required" v-slot="{errors}">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Url</span><span>*</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border
                    v-model="url" />
                </div>
              </div>
              <div class="text-right text-danger">{{ errors[0] }}</div>
            </validation-provider>
            <!-- end::url -->

            <!-- start::price_xpath -->
            <validation-provider rules="required" v-slot="{errors}">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Price Xpath</span><span>*</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="price_xpath" />
                </div>
              </div>
              <div class="text-right text-danger">{{ errors[0] }}</div>
            </validation-provider>
            <!-- end::price_xpath -->

            <!-- start::seller_xpath -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>E-shop Xpath</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="seller_xpath" />
              </div>
            </div>
            <!-- end::seller_xpath -->

            <!-- <div class="vx-row" v-if="!validateForm()" >
                     <vs-alert class="mt-5" >Παρακαλώ συμπληρώστε όλα τα πεδία με *.</vs-alert>
                 </div>-->
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button :disabled="invalid" class="mb-2 text-right" @click="addRecord">
                  Αποθήκευση
                </vs-button>
              </div>
            </div>
          </vs-popup>
        </form>
        <!-- end::form -->
      </validation-observer>
      <!-- end::validation observer -->
    </div>
    <!-- END: ADD NEW POPUP -->

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{
                                    currentPage * paginationPageSize - (paginationPageSize - 1)
                                }} - {{
                                    recordsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : recordsData.length
                                }} of {{ recordsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
          @input="updateSearchQuery" placeholder="Αναζήτηση..." />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true" :enableRtl="$vs.rtl" :paginationAutoPageSize="true" :filter="true"
        :resizable="true">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer
import CellRendererLink from './cell-renderer-sources/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-sources/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-sources/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer-sources/CellRendererActions.vue'

// Validation
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο!',
})

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    // Validation
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      initiated: false,
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Πηγή',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Price XPath',
          field: 'price_xpath',
          filter: 'agTextColumnFilter',
          flex: 2,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: 'Eshop XPath',
          field: 'seller_xpath',
          filter: 'agTextColumnFilter',
          flex: 2,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        {
          headerName: '',
          field: 'id',
          width: 80,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          filter: false,
          suppressNavigable: true,
          cellClass: 'no-border',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  events: {
    'do-something': function () {
      alert('arrived!')
    },
  },
  computed: {
    // Shops
    recordsData() {
      return this.$store.getters.getShops
    },
    // Shop
    item() {
      return this.$store.getters.getShop
    },
    // getter and setter for name
    name: {
      get() {
        return this.item.name
      },
      set(value) {
        this.$store.dispatch('setShopName', value)
      },
    },
    // getter and setter for url
    url: {
      get() {
        return this.item.url
      },
      set(value) {
        this.$store.dispatch('setShopUrl', value)
      },
    },
    // getter and setter for price_xpath
    price_xpath: {
      get() {
        return this.item.price_xpath
      },
      set(value) {
        this.$store.dispatch('setShopPriceXPath', value)
      },
    },
    // getter and setter for seller_xpath
    seller_xpath: {
      get() {
        return this.item.seller_xpath
      },
      set(value) {
        this.$store.dispatch('setShopSellerXPath', value)
      },
    },
    // getter and setter Display pop up
    displayPopUp() {
      return this.$store.getters.getDisplayShopPopUp
    },
    // Pop up title
    popUpTitle() {
      return this.$store.getters.getShopPopUpTitle
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
  },
  methods: {
    // Display pop up and prepare data.
    addOrEditShop() {
      // 1. Set pop up title
      this.$store.dispatch('setShopPopUpTitle', 'Δημιουργία νέας εγγραφής')
      // 2. Display pop up
      this.$store.dispatch('toggleShopsPopUp', true)
      // 3. Set shop as an empty object
      const payload = {
        name: '',
        url: '',
        price_xpath: '',
        seller_xpath: '',
      }
      this.$store.dispatch('setShop', payload)
    },
    // Close pop up
    closePopUp() {
      // 1. Set pop up title
      this.$store.dispatch('setShopPopUpTitle', '')
      // 2. Display pop up
      this.$store.dispatch('toggleShopsPopUp', false)
      // 3. Set shop as an empty object
      const payload = {}
      this.$store.dispatch('setShop', payload)
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: 'All',
            value: 'all',
          }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    // Add or update store
    addRecord() {
      // item.id exists update the shop.
      if (this.item.id) {
        this.$store
          .dispatch('updateShop', this.item)
          .then(() => {
            this.closePopUp()
            this.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
            })
          })
          .catch((err) => {
            this.$vs.notify({
              color: 'danger',
              title: 'Σφάλμα',
              position: 'top-right',
              text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
            })
            console.error(err)
          })
      } else {
        this.$store
          .dispatch('addNewShop', this.item)
          .then(() => {
            this.closePopUp()
            this.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
            })
          })
          .catch((err) => {
            this.$vs.notify({
              color: 'danger',
              title: 'Σφάλμα',
              position: 'top-right',
              text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
            })
            console.error(err)
          })
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created() {
    this.$store.dispatch('fetchShops')
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
